import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, IconButton } from "@mui/material";
import { Dropdown } from "../../../common_components/FormInputs";
const FiltersRow = ({ selectedLeague = "All", leagueOptions = [{ label: "All", value: "All" }], onLeagueChange, selectedTeam = "All", teamOptions = [{ label: "All", value: "All" }], onTeamChange, renderTeamSelect, onCopy, onExport, leagueLabel = "League", teamLabel = "Team", containerSx = {} }) => {
    const renderStyledValue = (label, value) => (_jsxs(Box, { sx: { display: "flex", gap: 0.5 }, className: "all-Font-Sizes", children: [_jsxs(Box, { sx: { fontWeight: 600, color: "#111827" }, children: [label, ":"] }), _jsx(Box, { sx: { color: "#9CA3AF", fontWeight: 500 }, children: value })] }));
    return (_jsxs(Box, { sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            flexWrap: { xs: "wrap", md: "nowrap" },
            ...containerSx
        }, children: [_jsxs(Box, { sx: {
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                    flexWrap: "wrap",
                    justifyContent: { xs: "flex-start", md: "flex-end" }
                }, children: ["                ", _jsx(Box, { sx: { width: 120 }, children: _jsx(Dropdown, { value: selectedLeague, onChange: (value) => onLeagueChange?.(value), options: leagueOptions.map(opt => ({
                                label: opt.label,
                                value: opt.value
                            })), displayValue: renderStyledValue(leagueLabel, leagueOptions.find(o => o.value === selectedLeague)?.label || selectedLeague), size: "md", sortByLabel: false }) }), _jsx(Box, { children: renderTeamSelect ? (renderTeamSelect()) : (_jsx(Dropdown, { value: selectedTeam, onChange: (value) => onTeamChange?.(value), options: teamOptions.map(opt => ({
                                label: opt.label,
                                value: opt.value
                            })), displayValue: renderStyledValue(teamLabel, teamOptions.find(o => o.value === selectedTeam)?.label || selectedTeam), size: "md", sortByLabel: false })) })] }), _jsxs(Box, { sx: { display: "flex", gap: 1.5, alignItems: "center" }, children: [onCopy && (_jsx(IconButton, { onClick: onCopy, sx: {
                            width: 36,
                            height: 36,
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            bgcolor: "#fff",
                            "&:hover": {
                                bgcolor: "#f9fafb",
                                borderColor: "#d1d5db"
                            }
                        }, children: _jsx("img", { src: "/assets/save.svg", alt: "" }) })), onExport && (_jsx(Button, { onClick: onExport, startIcon: _jsx("img", { src: "/assets/export.svg", alt: "" }), sx: {
                            height: 36,
                            px: 2,
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            bgcolor: "#fff",
                            color: "#374151",
                            fontSize: "14px",
                            fontWeight: 500,
                            textTransform: "none",
                            "&:hover": {
                                bgcolor: "#f9fafb",
                                borderColor: "#d1d5db"
                            }
                        }, children: "Export" }))] })] }));
};
export default FiltersRow;
